import React, { useEffect, useState } from "react";
import axios from "axios";
import classes from "./techOverview.module.scss";
import LoadingDots from "../UI/LoadingDots";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const AddCustomerTable = () => {
  const [apiDetails, setApiDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Metadata.DescribeService",
          params: {
            service: "EUeInvoices.AddCustomer",
          },
          id: 5,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.result) {
          setApiDetails(res.data.result);
          setIsLoading(false);
        }
      });
  }, []);

  return (
    <>
      {isLoading && <LoadingDots />}
      {apiDetails && !isLoading && (
        <>
          {Object.keys(apiDetails.properties).map((key) => {
            const { title, properties } = apiDetails.properties[key];
            return (
              <>
                <p>
                  An object with the name{" "}
                  <span className={classes["connection-key"]}>{title}</span> and
                  the following properties should be prepared:
                </p>
                <table className="mb-4">
                  <thead>
                    <th className="ps-2">Property name</th>
                    <th>Type</th>
                    <th>Description</th>
                  </thead>
                  {properties && (
                    <tbody>
                      {Object.keys(properties).map((prop) => {
                        const { title, description, type } =
                          apiDetails.properties[key].properties[prop];
                        return (
                          <tr>
                            <td className="ps-2">{title}</td>
                            <td className="text-center">{type}</td>
                            <td className="ps-2">{description}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  )}
                </table>
              </>
            );
          })}
          {apiDetails["$d3pro"].results && (
            <>
              <p>
                The expected response should contain the following elements:
              </p>
              <ul>
                <li>
                  <p>
                    <span className={classes["connection-key"]}>Status: </span>
                    {
                      apiDetails["$d3pro"].results[0].properties.Status
                        .description
                    }
                  </p>
                </li>
                <li>
                  <p>
                    <span className={classes["connection-key"]}>Result: </span>
                    {
                      apiDetails["$d3pro"].results[0].properties.Result
                        .description
                    }
                  </p>
                </li>
                <li>
                  <p>
                    <span className={classes["connection-key"]}>Reason: </span>
                    {
                      apiDetails["$d3pro"].results[0].properties.Reason
                        .description
                    }
                  </p>
                </li>
              </ul>
            </>
          )}
        </>
      )}
    </>
  );
};

export default AddCustomerTable;
